import client from '../utils/client';
import { categoriesUrl, postsCategoriesUrl} from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const categoryService = {
  getCategoriesResponse,
  createCategory,
  getCategory,
  updateCategory,
  deleteCategory
}

function getCategoriesResponse(type = '') {
  let categoriesAPI = categoriesUrl;
  if(type === 'posts') {
    categoriesAPI = postsCategoriesUrl;
  }
  return client.get(categoriesAPI)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function createCategory(formDate, type = '') {
  let categoriesAPI = categoriesUrl;
  if(type === 'posts') {
    categoriesAPI = postsCategoriesUrl;
  }
  return client.post(categoriesAPI + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getCategory(categoryID, type = '') {
  let categoriesAPI = categoriesUrl;
  if(type === 'posts') {
    categoriesAPI = postsCategoriesUrl;
  }
  return client.get(categoriesAPI + '/' + categoryID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateCategory(formDate, type = '') {
  let categoriesAPI = categoriesUrl;
  if(type === 'posts') {
    categoriesAPI = postsCategoriesUrl;
  }
  return client.post(categoriesAPI + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function deleteCategory(categoryID, type = '') {
  let categoriesAPI = categoriesUrl;
  if(type === 'posts') {
    categoriesAPI = postsCategoriesUrl;
  }
  return client.post(categoriesAPI + '/delete', {id: categoryID})
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}